__webpack_require__.p = "https://edycja.osuwiska.pgi.gov.pl/web/";